import { Box, Checkbox } from 'enova-frontend-components';
import { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  children: ReactNode;
  labelKey: string;
  helperTextKey?: string;
  onChange: (checked: boolean) => void;
  checked?: boolean;
  error?: boolean;
}

export const CollapseCheckbox: FC<Props> = ({ children, labelKey, helperTextKey, onChange, checked, error }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Checkbox
        error={error}
        checked={checked}
        onChange={(_, checked) => onChange(checked)}
        label={t(labelKey)}
        aria-label={t(labelKey)}
        helperText={helperTextKey ? t(helperTextKey) : undefined}
      />
      {checked && <Box p={3}>{children}</Box>}
    </Fragment>
  );
};
